import React from "react";
import { FaRegThumbsUp, FaChartBar, FaFileInvoice, FaRegHandshake, FaMoneyBillAlt, FaTruckMoving } from "react-icons/fa";
import "./TallyFieldPage.css";

const Taxation = () => {
  const sections = [
    {
      title: "Connected GST Solution",
      content: "Simplify your GST compliance with TallyPrime. Generate e-invoices, reconcile GSTR-2A, and upload returns directly.",
      icon: <FaRegThumbsUp />,
    },
    {
      title: "TallyPrime Instant Demo",
      content: "Explore TallyPrime's advanced GST features instantly with our interactive and guided product demo.",
      icon: <FaChartBar />,
    },
    {
      title: "e-Invoicing Suite",
      content: "Quickly generate and manage e-invoices directly from TallyPrime, reducing manual errors and increasing efficiency.",
      icon: <FaFileInvoice />,
    },
    {
      title: "Auto-Reconciliation",
      content: "Simplify your tax reconciliation process with automatic matching of GSTR-2B and GSTR-2A data for accuracy.",
      icon: <FaRegHandshake />,
    },
    {
      title: "Direct Returns Filing",
      content: "File your GST returns directly from TallyPrime with seamless upload features, eliminating manual data entry.",
      icon: <FaMoneyBillAlt />,
    },
    {
      title: "ITC Risk Insights",
      content: "Get detailed insights into Input Tax Credit (ITC) risks within your payables reports for better compliance.",
      icon: <FaChartBar />,
    },
    {
      title: "e-Way Bill Solution",
      content: "Generate, manage, and track e-way bills effortlessly within TallyPrime, simplifying your logistics operations.",
      icon: <FaTruckMoving />,
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Core Feature</span>
          <h1>Taxation & Compliance</h1>
          <p>Stay ahead of regulations with automated GST, TDS, and multi-state compliance features.</p>
        </header>

        <div className="tally-field-grid">
          {sections.map((section, index) => (
            <div className="tally-field-card" key={index}>
              <div className="icon-wrapper">
                {section.icon}
              </div>
              <div className="card-content">
                <h3>{section.title}</h3>
                <p>{section.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Taxation;
